import React from "react"
import { Box } from "@chakra-ui/react"
import { colours } from "@shared/ui.design-system"
import { fonts } from "theme/themeConfig"

const blockquoteCss = {
  p: {
    fontFamily: fonts.apercu,
    "margin-top": "0",
    letterSpacing: "0.1px",
  },
  span: {
    fontFamily: fonts.apercu,
    fontSize: "0.75rem",
    marginTop: "0.5rem",
    display: "block",
    color: colours.primary.dark,
    "line-height": "1.75rem",
    "text-transform": "uppercase",
  },
}

const showQuoteCss = {
  p: {
    "&:first-of-type": {
      "&:before": {
        content: '"\\201C"',
        marginLeft: "-10px",
      },
    },
    "&:last-of-type": {
      "&:after": {
        content: '"\\201D"',
      },
    },
  },
}

type Props = {
  children: React.ReactNode
  author?: string
  quote?: boolean
  showAuthor?: boolean
}

export const Blockquote: React.FC<Props> = ({
  children,
  author,
  quote,
  showAuthor,
}) => {
  return (
    <Box
      mx="auto"
      pl={{
        base: "1.75rem",
        md: "2rem",
      }}
      my="2rem"
      borderLeft="solid 1px #000"
      fontSize={{
        base: "1.125rem",
        md: "1.25rem",
      }}
      lineHeight={{
        base: "1.75rem",
        md: "1.75rem",
      }}
    >
      <Box
        as="blockquote"
        css={quote ? [blockquoteCss, showQuoteCss] : blockquoteCss}
      >
        {children}
        {showAuthor && <span>{author}</span>}
      </Box>
    </Box>
  )
}
